// extracted by mini-css-extract-plugin
module.exports = {"rejectMessage":"ReportSubmission_rejectMessage__10eOi"};